import { render } from "./LP-THLTruppaufgabe.vue?vue&type=template&id=36b86dfa"
import script from "./LP-THLTruppaufgabe.vue?vue&type=script&lang=js"
export * from "./LP-THLTruppaufgabe.vue?vue&type=script&lang=js"

import "./LP-THLTruppaufgabe.vue?vue&type=style&index=0&id=36b86dfa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__